import _ from 'lodash'

import { fetchTours } from './fetchTours';

export const FETCH_CONFIG_BEGIN   = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR'

export const fetchConfiguration = () => async dispatch => {
  let config = JSON.parse(localStorage.getItem('ylg_featured_listings_config'))
  if (config) {
    // check for title field or pass default
    config = {
      ...config,
      title: config.title || 'Other vacations <strong>you might like</strong>',
      // strip out whitespace from tourIds
      tourIds: _.get(config, 'tourIds', '').replace(/ /g,''),
    }
    dispatch({
      type: FETCH_CONFIG_SUCCESS,
      payload: config,
    })
    if (_.get(config, 'tourIds')) {
      dispatch(fetchTours())
    }
  }
}
